<template>
  <div
    class="infoWindow info_container vs-con-loading__container"
    style="width: 560px">
    <LiveShare :openModal="openModal" @closeModal="closeModal()" :data="id" />
    <vs-row vs-w="12">
      <vs-col
        vs-justify="center"
        vs-align="center"
        vs-lg="6"
        vs-sm="12"
        vs-xs="12">
        <h5>Vehicle Informations</h5>
        <table style="width: 100%">
          <tr>
            <td>GPS Date</td>
            <td>:</td>
            <td>
              <strong>{{ selectedLocation.device_time }} WIB</strong>
            </td>
          </tr>
          <tr>
            <td>Fleet Group</td>
            <td>:</td>
            <td>
              <strong>{{ selectedLocation.fleet_group_name }}</strong>
            </td>
          </tr>
          <tr>
            <td style="min-width: 84px">License Plate</td>
            <td>:</td>
            <td>
              <strong>
                {{ selectedLocation.license_plate }}
              </strong>
            </td>
          </tr>
          <tr>
            <td>Vehicle Model</td>
            <td>:</td>
            <td>
              <strong>
                {{ selectedLocation.vehicle_model }}
              </strong>
            </td>
          </tr>
          <tr>
            <td>Driver Name</td>
            <td>:</td>
            <td>
              <strong>
                {{ selectedLocation.driver_name }}
              </strong>
            </td>
          </tr>
          <tr>
            <td>Driver Phone</td>
            <td>:</td>
            <td>
              <strong>
                {{ selectedLocation.driver_phone }}
              </strong>
            </td>
          </tr>
          <tr>
            <td>Total Odometer</td>
            <td>:</td>
            <td>
              <strong>
                {{ commafy(selectedLocation.total_odometer / 1000) }}
                KM
              </strong>
            </td>
          </tr>
          <tr>
            <td>Latitude</td>
            <td>:</td>
            <td>
              <strong> {{ selectedLocation.latitude }} </strong>
            </td>
          </tr>
          <tr>
            <td>Longitude</td>
            <td>:</td>
            <td>
              <strong>
                {{ selectedLocation.longitude }}
              </strong>
            </td>
          </tr>
          <tr>
            <td>Location</td>
            <td>:</td>
            <td>
              <strong>
                <a
                  target="_blank"
                  :href="
                    'http://www.google.com/maps/place/' +
                    selectedLocation.latitude +
                    ',' +
                    selectedLocation.longitude
                  "
                  >Show Google Map</a
                >
              </strong>
            </td>
          </tr>

          <tr>
            <td>Street View</td>
            <td>:</td>
            <td>
              <strong>
                <a
                  target="_blank"
                  :href="
                    'https://www.google.com/maps?q&layer=c&cbll=' +
                    selectedLocation.latitude +
                    ',' +
                    selectedLocation.longitude +
                    '&cbp'
                  "
                  >Show Sreet View</a
                >
              </strong>
            </td>
          </tr>
        </table>
        <vs-row
          v-if="
            detailable &&
            getRolePermission().vehicle_details.vehicle_informations
              .read_vehicle_details
          "
          class="flex flex-row mt-5"
          style="gap: 8px">
          <vs-button
            @click="viewDetail2()"
            class="shadow float-left"
            type="gradient"
            color="#d23030"
            gradient-color-secondary="#f89595"
            >Vehicle Detail
          </vs-button>
          <vs-button color="danger" class="p-3" @click="openModal = true">
            <div class="flex flex-row-reverse items-center">
              <feather-icon icon="Share2Icon" svgClasses="w-5 h-5" />
            </div>
          </vs-button>
        </vs-row>
      </vs-col>
      <vs-col
        vs-justify="center"
        vs-align="center"
        vs-lg="6"
        vs-sm="12"
        vs-xs="12">
        <h5>Vehicle Status</h5>
        <table style="width: 100%">
          <tr>
            <td>Event Name</td>
            <td>:</td>
            <td>
              <strong>{{ selectedLocation.event_name }}</strong>
            </td>
          </tr>
          <tr>
            <td>Speed</td>
            <td>:</td>
            <td>
              <strong>{{ selectedLocation.speed }} km/jam</strong>
            </td>
          </tr>
          <tr>
            <td>Direction</td>
            <td>:</td>
            <td>
              <strong>
                {{ selectedLocation.direction
                }}<sup style="color: black">0</sup>
              </strong>
            </td>
          </tr>
          <tr>
            <td>Internal Battery</td>
            <td>:</td>
            <td>
              <strong>
                {{ format_number(selectedLocation.internal_battery_voltage) }} V
              </strong>
            </td>
          </tr>
          <tr>
            <td>External Battery</td>
            <td>:</td>
            <td>
              <strong>
                {{ format_number(selectedLocation.external_power_voltage) }} V
              </strong>
            </td>
          </tr>
          <!-- <tr>
            <td>Humidity</td>
            <td>:</td>
            <td>
              <span v-if="selectedLocation.humidity">
                <strong>
                  {{ format_number(selectedLocation.humidity) }}
                  %
                </strong>
              </span>
              <span v-else>
                <strong>-</strong>
              </span>
            </td>
          </tr> -->
          <tr>
            <td>Battery Level (eye sensor)</td>
            <td>:</td>
            <td>
              <span v-if="selectedLocation.eye_battery_level">
                <strong>
                  {{ format_number(selectedLocation.eye_battery_level) }}
                  %
                </strong>
              </span>
              <span v-else>
                <strong>-</strong>
              </span>
            </td>
          </tr>
          <tr>
            <td>Engine Status</td>
            <td>:</td>
            <td>
              <span v-if="selectedLocation.ignition == 0" style="color: red">
                <strong>OFF</strong>
              </span>
              <span v-if="selectedLocation.ignition == 1" style="color: green">
                <strong> ON</strong>
              </span>
            </td>
          </tr>
          <!-- <tr>
            <td>SOS</td>
            <td>:</td>
            <td>
              <span v-if="checkStatus('panic', 'ON')" style="color: red"
                ><strong> ON </strong></span
              >
              <span v-if="checkStatus('panic', 'OFF')" style="color: green"
                ><strong> OFF </strong></span
              >
              <span v-if="checkStatus('panic', '')"><strong> - </strong></span>
            </td>
          </tr> -->

          <tr>
            <td>Left Door</td>
            <td>:</td>
            <td>
              <span v-if="checkStatus('dleft', 'OPEN')" style="color: red"
                ><strong> OPEN </strong></span
              >
              <span v-if="checkStatus('dleft', 'CLOSED')" style="color: green"
                ><strong> CLOSE </strong></span
              >
              <span v-if="checkStatus('dleft', '')"><strong> - </strong></span>
            </td>
          </tr>
          <tr>
            <td>Right Door</td>
            <td>:</td>
            <td>
              <span v-if="checkStatus('dright', 'OPEN')" style="color: red"
                ><strong> OPEN </strong></span
              >
              <span v-if="checkStatus('dright', 'CLOSED')" style="color: green"
                ><strong> CLOSE </strong></span
              >
              <span v-if="checkStatus('dright', '')"><strong> - </strong></span>
            </td>
          </tr>
          <tr>
            <td>Rear Door</td>
            <td>:</td>
            <td>
              <span v-if="checkStatus('drear', 'OPEN')" style="color: red"
                ><strong> OPEN </strong></span
              >
              <span v-if="checkStatus('drear', 'CLOSED')" style="color: green"
                ><strong> CLOSE </strong></span
              >
              <span v-if="checkStatus('drear', '')"><strong> - </strong></span>
            </td>
          </tr>
          <tr>
            <td>Chiller Temp 1</td>
            <td>:</td>
            <td>
              <strong>
                {{ formatFloat(selectedLocation.dallas_temperature_1) }}
                <sup style="color: black">0</sup>C</strong
              >
            </td>
          </tr>
          <tr>
            <td>Chiller Temp 2</td>
            <td>:</td>
            <td>
              <strong>
                {{ formatFloat(selectedLocation.dallas_temperature_2) }}
                <sup style="color: black">0</sup>C</strong
              >
            </td>
          </tr>
        </table>
      </vs-col>
    </vs-row>
    <!--<vs-button  @click="playBack()" class="mt-4 ml-2 shadow float-left" type="gradient" color="#d23030" gradient-color-secondary="#f89595">Play Back</vs-button>-->
  </div>
</template>

<script>
import LiveShare from './LiveShare.vue'
export default {
  props: {
    selectedLocation: Object,
    detailable: Boolean,
  },
  components: {
    LiveShare,
  },
  data() {
    return {
      openModal: false,
      id: '',
    }
  },
  mounted() {
    this.id = this.selectedLocation.vehicle_id
    //
  },
  methods: {
    closeModal() {
      this.openModal = false
    },
    formatFloat(val) {
      return parseFloat(val).toFixed(1)
    },
    format_number(val) {
      if (val) {
        let tmp = Math.round(val)
        return tmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      } else {
        return val
      }
    },
    viewDetail2() {
      this.$vs.loading({
        container: '#data-list-list-view',
        scale: 1,
      })

      //

      this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
      //
      this.$router.push(
        '/monitoring-vehicle/' + this.selectedLocation.vehicle_id
      )

      // this.infoBoxOpen=false;
    },
    checkStatus(key, val) {
      let selected = JSON.parse(JSON.stringify(this.selectedLocation))
      //
      if (key in selected) {
        if (selected[key] == val) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    commafy(num) {
      if (!num) return num
      num = num.toString().split('.')[0]
      var str = num.toString().split('.')
      if (str[0].length >= 4) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.')
      }
      if (str[1] && str[1].length >= 5) {
        str[1] = str[1].replace(/(\d{3})/g, '$1 ')
      }
      return str.join('.')
    },
  },
}
</script>

<style lang="scss" scoped></style>
